import { restClient } from '../config/restClient'

const endpoint = `/api/current_user`

export const getCurrentUser = async () => {
  const response = await restClient(endpoint, {
    method: 'GET',
  })
  return response.data
}
